export const waveBorderSrc =
  'https://images.ctfassets.net/0sea1vycfyqy/3WNHNjtQGz9gy9V6CFHGk1/99c96627354a19553b56af91501c0a63/wave-border-full-edited__10___1_.webp?h=250';
